"use client";

import { c as _c } from "react/compiler-runtime";
import { ComboboxItem, JollyComboBox } from "@/components/rac/combobox";
import { Input } from "@/components/rac/input";
import { type Country, getCountriesWithPhoneCodes } from "@/info/countries";
import { isValidPhoneNumber } from "@/info/login";
import { type ChangeEvent, useState } from "react";
import { Label } from "react-aria-components";
import { useController } from "react-hook-form";
interface PhoneWithCountryFieldProps {
  name: string;
  control: any;
  label?: string;
  phonePlaceholder?: string;
  countryPlaceholder?: string;
  isDisabled?: boolean;
  hideError?: boolean;
  phoneVerified?: boolean;
}
export function PhoneWithCountryField(t0) {
  const $ = _c(41);
  const {
    name,
    control,
    label: t1,
    phonePlaceholder: t2,
    countryPlaceholder: t3,
    isDisabled: t4,
    hideError: t5,
    phoneVerified: t6
  } = t0;
  const label = t1 === undefined ? "Phone Number" : t1;
  const phonePlaceholder = t2 === undefined ? "Enter your number" : t2;
  const countryPlaceholder = t3 === undefined ? "Search countries..." : t3;
  const isDisabled = t4 === undefined ? false : t4;
  const hideError = t5 === undefined ? false : t5;
  const phoneVerified = t6 === undefined ? false : t6;
  let t7;
  if ($[0] !== control || $[1] !== name) {
    t7 = {
      name,
      control
    };
    $[0] = control;
    $[1] = name;
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  const {
    field: t8
  } = useController(t7);
  const {
    value,
    onChange
  } = t8;
  const countries = getCountriesWithPhoneCodes();
  const getCountryAndPhone = combinedValue => {
    const india = countries.find(_temp) ?? countries[0];
    if (!combinedValue) {
      return {
        country: india,
        phone: ""
      };
    }
    const country_1 = countries.find(country_0 => combinedValue.startsWith(`${country_0.code}`));
    if (country_1) {
      const phone = combinedValue.replace(`${country_1.code}`, "");
      return {
        country: country_1,
        phone
      };
    }
    return {
      country: india,
      phone: combinedValue
    };
  };
  const {
    country: selectedCountry,
    phone: displayPhone
  } = getCountryAndPhone(value);
  const [currentCountry, setCurrentCountry] = useState(selectedCountry);
  const handleCountryChange = country_2 => {
    setCurrentCountry(country_2);
    const phoneOnly = displayPhone || "";
    const combined = `${country_2.code}${phoneOnly}`;
    onChange(combined);
  };
  let t9;
  if ($[3] !== currentCountry.code || $[4] !== onChange) {
    t9 = event => {
      const cleaned = event.target.value.replace(/[^\d]/g, "");
      const combined_0 = `${currentCountry.code}${cleaned}`;
      onChange(combined_0);
    };
    $[3] = currentCountry.code;
    $[4] = onChange;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  const handlePhoneChange = t9;
  let t10;
  if ($[6] !== currentCountry.code || $[7] !== value) {
    t10 = value?.length === 0 || isValidPhoneNumber(value, currentCountry.code);
    $[6] = currentCountry.code;
    $[7] = value;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  const isValid = t10;
  const t11 = "flex flex-col gap-1";
  let t12;
  if ($[9] !== label) {
    t12 = <Label className="text-title-medium">{label}</Label>;
    $[9] = label;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  const t13 = "flex items-center gap-3 w-full";
  const t14 = "relative flex-shrink-0 w-32";
  const T0 = JollyComboBox;
  const t15 = "focus";
  const t16 = currentCountry?.countryCode;
  const t17 = key => {
    if (!key) {
      return;
    }
    const country_3 = countries.find(c => c.countryCode === key);
    if (country_3) {
      handleCountryChange(country_3);
    }
  };
  const t18 = `h-10 text-sm border rounded-md transition-all duration-200 ${isDisabled ? "opacity-50 cursor-not-allowed" : "border-gray-300"}`;
  const t19 = countries.map(_temp2);
  let t20;
  if ($[11] !== T0 || $[12] !== countryPlaceholder || $[13] !== isDisabled || $[14] !== t16 || $[15] !== t17 || $[16] !== t18 || $[17] !== t19) {
    t20 = <div className={t14}><T0 placeholder={countryPlaceholder} menuTrigger={t15} selectedKey={t16} onSelectionChange={t17} isDisabled={isDisabled} className={t18}>{t19}</T0></div>;
    $[11] = T0;
    $[12] = countryPlaceholder;
    $[13] = isDisabled;
    $[14] = t16;
    $[15] = t17;
    $[16] = t18;
    $[17] = t19;
    $[18] = t20;
  } else {
    t20 = $[18];
  }
  const t21 = `h-10 px-3 py-2 text-sm border rounded-md transition-all duration-200 touch-manipulation ${isValid ? "border-gray-300" : "border-red-300"} ${isDisabled ? "opacity-50 cursor-not-allowed" : ""}`;
  let t22;
  if ($[19] !== displayPhone || $[20] !== handlePhoneChange || $[21] !== isDisabled || $[22] !== phonePlaceholder || $[23] !== t21) {
    t22 = <Input type="tel" value={displayPhone} onChange={handlePhoneChange} placeholder={phonePlaceholder} className={t21} disabled={isDisabled} autoComplete="tel" inputMode="numeric" maxLength={10} />;
    $[19] = displayPhone;
    $[20] = handlePhoneChange;
    $[21] = isDisabled;
    $[22] = phonePlaceholder;
    $[23] = t21;
    $[24] = t22;
  } else {
    t22 = $[24];
  }
  let t23;
  if ($[25] !== phoneVerified) {
    t23 = phoneVerified && <span className="absolute right-3 top-1/2 -translate-y-1/2 bg-blue-600 text-white text-xs px-2 py-1 rounded">verified</span>;
    $[25] = phoneVerified;
    $[26] = t23;
  } else {
    t23 = $[26];
  }
  let t24;
  if ($[27] !== t22 || $[28] !== t23) {
    t24 = <div className="relative flex-1 min-w-0">{t22}{t23}</div>;
    $[27] = t22;
    $[28] = t23;
    $[29] = t24;
  } else {
    t24 = $[29];
  }
  let t25;
  if ($[30] !== t20 || $[31] !== t24) {
    t25 = <div className={t13}>{t20}{t24}</div>;
    $[30] = t20;
    $[31] = t24;
    $[32] = t25;
  } else {
    t25 = $[32];
  }
  let t26;
  if ($[33] !== hideError || $[34] !== isValid || $[35] !== value?.length) {
    t26 = !hideError && !isValid && value?.length > 0 && <p className="text-xs text-red-600 mt-1">Please enter a valid phone number</p>;
    $[33] = hideError;
    $[34] = isValid;
    $[35] = value?.length;
    $[36] = t26;
  } else {
    t26 = $[36];
  }
  let t27;
  if ($[37] !== t12 || $[38] !== t25 || $[39] !== t26) {
    t27 = <div className={t11}>{t12}{t25}{t26}</div>;
    $[37] = t12;
    $[38] = t25;
    $[39] = t26;
    $[40] = t27;
  } else {
    t27 = $[40];
  }
  return t27;
}
function _temp2(country_4) {
  return <ComboboxItem key={country_4.countryCode} id={country_4.countryCode} textValue={`${country_4.flag} ${country_4.code}`}>{country_4.flag} {country_4.code}</ComboboxItem>;
}
function _temp(country) {
  return country.code === "+91";
}